import styled from "styled-components";
import { tokens } from "@companycam/slab";

import Modal from 'components/shared/DesignSystem/Modal';

export const ReportTemplateModal = styled(Modal)`
  position: relative;
  height: 85vh;
  min-height: 450px;
  @media (min-width: 768px) {
    width: 90vw;
    max-width: 900px;
  }
`;
export const CenteredLayout = styled.div`
  height: 100%;
  padding: ${tokens.size_spacing_l}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Error = styled.div`
  text-align: center;
`;
export const ErrorText = styled.div`
  font-size: ${tokens.size_text_m}px;
  color: ${tokens.color_text_subtle_le};
  line-height: 1.5;
  margin: ${tokens.size_spacing_xs}px 0 ${tokens.size_spacing_l}px;
`;
const sharedMessageIconStyles = `
  display: inline-block;
  font-size: 40px;
  margin-block-end: ${tokens.size_spacing_m}px;
`;
export const ErrorIcon = styled.i`
  ${sharedMessageIconStyles}
  color: ${tokens.color_utility_destroy};
`;
export const TemplateIcon = styled.i`
  ${sharedMessageIconStyles}
  color: ${tokens.color_link_primary_le};
`;
